import { supabase } from "@/integrations/supabase/client";

export interface ConversationRow {
  id: string;
  user_id: string;
  created_at: string;
  ended_at: string | null;
  title: string | null;
}

export interface MessageRow {
  id: string;
  conversation_id: string;
  role: string;
  content: string;
  image_url: string | null;
  created_at: string;
}

export async function fetchConversations(): Promise<ConversationRow[]> {
  const { data, error } = await supabase
    .from("agent_conversations")
    .select("*")
    .order("created_at", { ascending: false });

  if (error) throw error;
  return data ?? [];
}

export async function createConversation(
  userId: string,
  title?: string
): Promise<string> {
  const { data, error } = await supabase
    .from("agent_conversations")
    .insert({ user_id: userId, title: title || null })
    .select("id")
    .single();

  if (error) throw error;
  return data.id;
}

export async function updateConversationTitle(
  id: string,
  title: string
): Promise<void> {
  const { error } = await supabase
    .from("agent_conversations")
    .update({ title })
    .eq("id", id);

  if (error) throw error;
}

export async function endConversation(id: string): Promise<void> {
  const { error } = await supabase
    .from("agent_conversations")
    .update({ ended_at: new Date().toISOString() })
    .eq("id", id);

  if (error) throw error;
}

export async function fetchMessages(conversationId: string): Promise<MessageRow[]> {
  const { data, error } = await supabase
    .from("agent_messages")
    .select("*")
    .eq("conversation_id", conversationId)
    .order("created_at", { ascending: true });

  if (error) throw error;
  return data ?? [];
}

export async function insertMessage(data: {
  conversation_id: string;
  role: string;
  content: string;
  image_url?: string | null;
}): Promise<void> {
  const { error } = await supabase.from("agent_messages").insert({
    conversation_id: data.conversation_id,
    role: data.role,
    content: data.content,
    image_url: data.image_url ?? null,
  });

  if (error) throw error;
}
